export default __webpack_public_path__ + "static/media/Water_1_M_Normal.54caffa4.jpg";